import React, { ReactChild } from 'react';
import { AuthContext } from './AuthContext';
import { useProvideAuth } from './hooks/ProvideAuth';

interface IProvideAuthProps {
    children: ReactChild[]
}

export function ProvideAuth({ children }: IProvideAuthProps) {
    const auth = useProvideAuth();
    return (
        <AuthContext.Provider value={auth}>
            {children}
        </AuthContext.Provider>
    );
}